import lodash from "lodash";
import { createFieldSelect } from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import store from "../../../../../../store";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import { createLoading } from "../../../../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/samplingDistributor";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callUser = ({ searchQuery }) => {
    const where = [
        // user
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
    ];
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "fullNameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "companyNameTh", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "companyNameTh", "companyNameEn", "idCard", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "fullNameTh", type: "ASC" },
                ],
            }
        })
        .then(page => page.data);
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refDistributor`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.samplingDistributor.refDistributor"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDistributor,
                            "onUpdate:value": value => {
                                model.isSave = true;
                                model.refDistributor = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callUser({ searchQuery }),
                            optLabel: "companyNameTh",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.fullNameTh`) }
            }),
        ]
    });
};

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    let items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    let initItems = itemsKey ? lodash.get(initialModel, itemsKey) : initialModel;
    fetchData({ props, data }).then(page => {
        const fetchItems = page.data.map(d => ({ ...d }));
        items?.push(...lodash.cloneDeep(fetchItems));
        initItems?.push(...lodash.cloneDeep(fetchItems));
    });
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
